import amplitude from 'amplitude-js';


export default amplitudeConfig => {
    console.log("INIT AMPLITUDE", amplitudeConfig.apiKey)
    amplitude.getInstance().init(amplitudeConfig.apiKey);
}